<template>
    <span
        v-if="wikiPath.startsWith('https')"
        style="cursor: pointer"
        @click="onClick"
    >
        <slot />{{ getText() }}
    </span>
    <router-link
        v-else
        :to="wikiPath"
        :tag="tag"
        class="static-link"
    ><slot />{{ getText() }}</router-link>
</template>

<script>
    import { capitalize } from '@superbet-group/web.lib.utilities';
    import { RouteName } from '@app/router/constants/RouteName';
    import { getWikiPath } from '@modules/wiki/navigateToWiki';

    export default {
        name: 'StaticLink',
        props: {
            path: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: false,
                default: null,
            },
            shouldCapitalize: {
                type: Boolean,
                default: true,
            },
            tag: {
                type: String,
                default: 'a',
            },
        },
        created() {
            this.RouteName = RouteName;
            this.wikiPath = getWikiPath(this.path);
        },
        methods: {
            getText() {
                const t = this.$t(this.label);
                if (this.shouldCapitalize) {
                    return capitalize(t);
                }
                return t;
            },
            onClick() {
                window.open(this.wikiPath, '_blank');
            },
        },
    };
</script>
